export class BusinessInformation {

  isPartOfControlledGroup: boolean;
  controllingEntityName?: string;
  controlledEntityAppliedLaCredit: boolean;
  appliedOtherLedPrograms: boolean;
  otherLedProgramsList: string[];
  appliedLARDCredit: boolean;
  isFiscal: boolean;
  taxYear: number;
  fiscalYearEnd: Date;
  hasAppliedCurrentTaxYear: boolean;
  businessControlNames: string;

  website: string;
  district: string;
  senator: string;
  representative: string;
  thirdPartyConsultant: string;

  naicsCode: string;
  deptRevenueID: string;
  federalTaxID: string;
  unemploymentID: string;

  constructor(businessInfo?: any) {

  }

}
